module.exports = __webpack_public_path__ + "img/rg.76e4ce93.png";